import { Box } from 'grommet'
import styled from 'styled-components'

export const Wrapper = styled(Box)`
  .image-subtitle {
    text-align: center;
  }
  .image-subtitle {
    ${({ theme }) => theme.below.tablet`
     font-size: ${({ theme }) =>
       theme.typography.mobile.title.title4.fontSize}px;
      line-height: ${({ theme }) =>
        theme.typography.mobile.title.title4.lineHeight}px;
    `}
  }

  .image-section-image-wrapper {
    ${({ theme }) => theme.below.mobileXL`
      height: 390px;
    `}
  }
  .image-section-title-hide {
    ${({ theme }) => theme.below.mobileXL`
    bottom: 300px;
  `}
  }

  .image-section-title {
    ${({ theme }) => theme.below.mobileXL`
      ${theme.getTypography('desktop', 'title', 'title1')}

      span {
        ${theme.getTypography('desktop', 'title', 'title1')}
      }
    `}
  }
`
